import React, { useState } from 'react';

import { IconButton } from '@mui/material';
import { Eye, EyeSlash } from 'iconsax-react';

import { palette } from 'styles/theme';

export const defaultMaskFn = (value: string): string => {
  if (!value) return '';
  if (value.length <= 4) return value;
  return '*'.repeat(value.length - 4) + value.slice(-4);
};

type Props = {
  value: string;
  canReveal: boolean;
  maskFn?: (value: string) => string;
};

export const MaskedSensitiveField: React.FC<Props> = ({
  value,
  canReveal,
  maskFn = defaultMaskFn,
}) => {
  const [revealed, setRevealed] = useState(false);

  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
      <span
        style={{
          fontFamily: 'monospace',
          letterSpacing: revealed ? 'normal' : '0.05em',
        }}
      >
        {revealed ? value : maskFn(value)}
      </span>
      {canReveal && (
        <IconButton
          size="small"
          onClick={e => {
            e.stopPropagation();
            setRevealed(prev => !prev);
          }}
          style={{ padding: '0.1rem' }}
          aria-label={revealed ? 'Hide number' : 'Reveal number'}
        >
          {revealed ? (
            <EyeSlash
              variant="TwoTone"
              color={palette.primary900}
              size="0.9rem"
            />
          ) : (
            <Eye variant="TwoTone" color={palette.primary900} size="0.9rem" />
          )}
        </IconButton>
      )}
    </span>
  );
};
